export default function fnOrNoop(fn?: () => void) {
  return (
    fn ||
    function () {
      // do nothing
    }
  );
}
